import React from 'react';
import './RankingList.css';
import {formatBigNumbers} from '../../../Helpers.js';

import loader from 'static/img/loader.gif';

const RankingList = (props) =>{
  let rank = 0;
  let rankSkip = 1;
  let prevPoints = 0;
  let rankingList = props.ranking.map( (i, index)=> {
    const currentPoints = Math.floor(i.points);
    if(currentPoints === prevPoints){
      rankSkip++;
    } else {
      rank = rank + rankSkip;
      rankSkip = 1;
    }
    prevPoints = currentPoints;
    i.rank = rank;
    return(i);
  });

  let substring = (typeof props.rankingInputFilter !== 'undefined' ? props.rankingInputFilter.toLowerCase().replace(/\s/g, '') : '');

  return (
    <ol className="RankingList">
      {props.rankingLoading ? (
        <li>
          <img src={loader} alt="loader" style={{width: '150px', margin: '0 auto', display: 'block'}} />
        </li>
      ) : (
        (rankingList.length === 0 ?
          <li style={{textAlign: 'center', fontSize: '14px'}}>{(props.period === 'current' ? 'Be the first participant of this month!' : 'Couldn’t find any participant :(' )}</li> :
          rankingList.map( (i, index)=> {
            if((i.athleteFirstName+i.athleteLastName).toLowerCase().includes(substring)){
              return(
                <li key={i.athleteId} className={`RankingListItem ${i.rank === 1 ? 'leader' : ''}`}>
                  <div className="RankingListItem-rank">{i.rank}</div>
                  <div className="RankingListItem-avatar">
                    <img src={i.avatarUri} alt="" className="RankingListItem-image"/>
                  </div>
                  <div className="RankingListItem-name">{`${i.athleteFirstName} ${i.athleteLastName}`}</div>
                  <div className="RankingListItem-points">{formatBigNumbers(Math.floor(i.points))}</div>
                </li>
              );
            }

            return null;
          })
        )
      )}
    </ol>
  )
}

export default RankingList;



// WEBPACK FOOTER //
// ./src/screens/bfmPanel/RankingList/RankingList.js